import { type FacilityNotification, type TypeAlertSettings, type TypeNotify } from "./types";

export type GranularControl = Record<"EMAIL" | "SMS", FacilityNotification[]>;

interface UserInfoWithAlertSettings {
  [key: string]: unknown;
  alertSettings?: TypeAlertSettings;
  notify?: TypeNotify;
}

export function createNotifyRoles(
  userInfo: UserInfoWithAlertSettings,
  granularControl?: GranularControl
): UserInfoWithAlertSettings {
  let alertSettings: TypeAlertSettings | undefined;
  const notifySettings: Record<string, Record<string, boolean>> = { EMAIL: {}, SMS: {} };

  if (granularControl) {
    const keys = Object.keys(granularControl);

    alertSettings = keys.reduce<TypeAlertSettings>((accumulatorOuter, key) => {
      const values = (granularControl as Record<string, FacilityNotification[]>)[key].reduce<
        Record<string, FacilityNotification["default"]>
      >((accumulator, item) => {
        if (item.action !== "All" && item.role && !notifySettings[key][item.role]) {
          notifySettings[key][item.role] = item.default.enabled;
        }

        return { ...accumulator, [item.action]: item.default };
      }, {});
      return { ...accumulatorOuter, [key]: { ...values } };
    }, {} as TypeAlertSettings);
  }

  return {
    ...userInfo,
    alertSettings,
    notify: { ...userInfo.notify, ...notifySettings },
  };
}
